import axios, { refreshSession } from './BaseService';
import { clearToken, setToken } from './tokenStore';

const API_URL =
    process.env.REACT_APP_API_URL || window._env_?.REACT_APP_API_URL;

export async function doLogin(email, password) {
    const loginUrl = `${API_URL}/auth/admin/login`;
    const response = await axios.post(loginUrl, {
        email,
        password,
    });
    return response.data;
}

export async function doLogout() {
    const logoutUrl = `${API_URL}/auth/admin/logout`;
    const response = await axios.post(logoutUrl, {});
    return response.data;
}

export function storeSession(session) {
    setToken(session.token);
}

export function clearSession() {
    clearToken();
}

// Called once before the app renders: a reload lost the in-memory token, but
// the httpOnly refresh cookie can still mint a new one.
export async function restoreSession() {
    // Older builds kept the token in localStorage.
    localStorage.removeItem('token');
    try {
        storeSession(await refreshSession());
    } catch (err) {
        clearSession();
    }
}
